import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';
import MuiInputBase from './MuiInputBase';
import MuiAutocomplete from './MuiAutocomplete';
import MuiAlert from './MuiAlert';

export default {
  MuiButton,
  MuiIconButton,
  MuiPaper,
  MuiTableCell,
  MuiTableHead,
  MuiTypography,
  MuiInputBase,
  MuiAutocomplete,
  MuiAlert,
};
